module.exports = __webpack_public_path__ + "static/media/custom-ex-3.9f5dedfe.jpg";